/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { fetchConToken } from 'helpers/fetch';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import WarningIcon from '@mui/icons-material/Warning';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BurstModeIcon from '@mui/icons-material/BurstMode';
import RateReviewIcon from '@mui/icons-material/RateReview';
import TaskIcon from '@mui/icons-material/Task';
import DescriptionIcon from '@mui/icons-material/Description';
import BallotIcon from '@mui/icons-material/Ballot';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import InfoIcon from '@mui/icons-material/Info';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Checkbox from '@mui/material/Checkbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import { GaleriaImg, AddImg } from '../ListImg';
import { GeneralForm } from './GeneralForm';
import { FormCategoria } from '../CategoriaList';
import { FormFichaTecnica } from '../FichaTecnica';
import { FormCostos } from '../Costos';
import { FormPublicador } from './FormPublicador';
import Add_Img from 'images/panel/add-image.png'

const TablePublicador = (props) => {
    return (<>
        {props.loading && (<div className='card row' style={{ height: '10vw', background: '#F5F5F5' }}>
            <div style={{ height: '4vw' }} />
            <div className='col-md-12 row'>
                <div className='col-sm-5' />
                <div className='col-sm-1' style={{ display: 'grid' }}><div className='card-body text-start'><CircularProgress /></div></div>
                <div className='col-sm-5' />
            </div>
        </div>)}
        {!props.loading && props.items?.map((item) => (<RowPublicador
            key={item.id}
            item={item}
            tienda={props.tienda}
            checked={props.check}
            onCountCheckdChange={props.onCountCheckdChange}
            onDeleteItem={props.onDeleteItem}
            claveCategoria={props.claveCategoria}
            SetClaveCategoria={props.SetClaveCategoria}
            saveCategorias={props.saveCategorias}
            SaveArtSimple={props.SaveArtSimple}
            SaveArtImg={props.SaveArtImg}
            SaveArtAtributos={props.SaveArtAtributos}
        />))}
        {props.pagination && (<TablePagination
            rowsPerPageOptions={props.rowsPerPageOptions ?? [5, 10, 25, 50, 100]}
            component="div"
            count={props.count ?? 0}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
        />)}
    </>);
}

const RowPublicador = (props) => {
    const [chekcd, setCheckd] = useState(false);
    const handleChange = (event) => {
        setCheckd(event.target.checked);
        props.onCountCheckdChange(event);
        props.item.checked = event.target.checked;
    }

    useEffect(() => {
        props.item.checked = props.checked !== 'T' ? props.checked === 'A' : false;
        if (props.checked !== 'T') setCheckd(props.checked === 'A');
        else setCheckd(false);
    }, [props.checked])

    return (<>
        <div className='card' style={{ background: '#F5F5F5' }}>
            <div className='col-md-12 row'>
                <div className='col-md-2 row'>
                    <div className='col-md-1' />
                    <div className='col-md-3 container-center'><Checkbox checked={chekcd} onChange={handleChange} /></div>
                    <div className='col-md-7 container-center'><Img item={props.item} /></div>
                </div>
                <div className='col-md-7' style={{ display: 'grid' }}><Info item={props.item} /></div>
                <div className='col-md-2' style={{ display: 'grid' }}><LogBasic item={props.item} tienda={props.tienda} /></div>
                <div className='col-md-1 container-center'><MenuRow
                    item={props.item}
                    tienda={props.tienda}
                    onDeleteItem={props.onDeleteItem}
                    claveCategoria={props.claveCategoria}
                    SetClaveCategoria={props.SetClaveCategoria}
                    saveCategorias={props.saveCategorias}
                    SaveArtSimple={props.SaveArtSimple}
                    SaveArtImg={props.SaveArtImg}
                    SaveArtAtributos={props.SaveArtAtributos} /></div>
            </div>
        </ div>
        <div className='espacio10px' />
    </>);
}

const Img = ({ item }) => {
    const [portada, setPortada] = useState(null);
    useEffect(() => { if (item.imagenes && item.imagenes.length > 0) setPortada(item.imagenes[0]); }, [])

    return (<div className='img_art_card'>
        <div className='espacio_img' />
        {portada ? (<img src={portada?.urlImagen ?? Add_Img} alt={Add_Img} className='card' />) : (<AddImg />)}
    </div>);
}

const Info = ({ item }) => {
    const { t } = useTranslation("common");
    const [categoria, setCategoria] = useState('');
    const loadDataCategoria = async (query) => await fetchConToken(`Categorias/GetCategoriByHijo?categoria=${query}`).then((resp) => {
        setCategoria(GetNombreCategoria(resp));
    }).catch(() => { setCategoria('Sin categoria') });

    const GetNombreCategoria = (categoria) => {
        let aux = categoria.nombre;
        if (categoria.sub_Categoria && categoria.sub_Categoria.length > 0) aux = `${aux} > ${GetNombreCategoria(categoria.sub_Categoria[0])}`;

        return aux;
    }

    const GetTipoPublicacion = () => {
        switch (item.tipo_Publicacion) {
            case 'gold_pro': return t('app.Articulos.form.tipoPublicacionGoldPro');
            case 'gold_special': return t('app.Articulos.form.tipoPublicacionGoldSp');
            case 'free': return t('app.Articulos.form.tipoPublicacionFree');
            default: return item.tipo_Publicacion;
        }
    }

    useEffect(() => { loadDataCategoria(item.clave_Categoria); }, [])

    return (<div style={{ display: 'grid' }}>
        <label className='form-label'>{item.nombre}</label>
        <label style={{ fontSize: 'small' }}>{categoria}</label>
        <div className='row'>
            <div className='col-sm-3 text-center'><label className='text-card'>SKU:{item.sku}</label></div>
            <div className='col-sm-3 text-center'><label className='text-card'>{item.existencias} en stock</label></div>
            <div className='col-sm-3 text-center'><label className='text-card'>${item.costo_Unidad}</label></div>
            <div className='col-sm-3 text-center'><label className='text-card'>{GetTipoPublicacion()}</label></div>
        </div>
        <div className='espacio5px' />
    </div>);
}

const LogBasic = ({ item, tienda }) => {
    return (<>
        <LogBasicRow title='Imagenes' status='fail' />
        <LogBasicRow title='Descripcion' status='success' />
        <LogBasicRow title='Categorizacion' status='fail' />
        {tienda === 'MERCADOLIBRE' && <LogBasicRow title='Atributos' status='warning' />}
        <div className='espacio5px' />
    </>);
}

const LogBasicRow = ({ title, status }) => {
    const StatusIcon = () => {
        switch (status?.toUpperCase()) {
            case 'FAIL': return (<ClearIcon style={{ color: 'red' }} />);
            case 'SUCCESS': return (<DoneIcon style={{ color: 'green' }} />);
            case 'WARNING': return (<WarningIcon style={{ color: 'gold' }} />);
            default: return (<LinkOffIcon />);
        }
    }

    return (<div className='row'>
        <div className='col-md-12 row'>
            <div className='col-sm-6'><label className='text-card'>{title}</label></div>
            <div className='col-sm-6 text-right' style={{ display: 'none' }}><label className='text-card'>{StatusIcon()}</label></div>
        </div>
    </div>);
}

const MenuRow = ({ item, onDeleteItem, tienda, claveCategoria, SetClaveCategoria, saveCategorias, SaveArtSimple, SaveArtImg, SaveArtAtributos }) => {
    const [keyModal, setKeyModal] = useState('general');
    const [anchorEl, setAnchorEl] = useState(null);
    const [articulo, ] = useState(item);
    const [modalKey, setModalKey] = useState(0);
    const [isOpenModal, openModal, closeModal] = useModal(false);
    const open = Boolean(anchorEl);
    const GetModalByMenu = () => {
        switch (keyModal) {
            case 'detalles': return (<FormPublicador key={modalKey} id={item.id} tienda={tienda} sucursalId={item.sucursal_Id} onClose={closeModal} />);
            case 'imagenes': return (<GaleriaImg key={modalKey} data={item} isAdd={true} isEdit={true} saveData={SaveImgArt} onClose={closeModal} />);
            case 'descripcion': return (<FormDescripcion key={modalKey} item={item} Save={SaveArt} CloseModal={closeModal} />);
            case 'categoria': return (<FormCategoria
                key={modalKey}
                data={articulo}
                HandleChangePrincipal={handleChangeCategoria}
                categorias={articulo.categorias || []}
                tienda={tienda}
                sucursal={articulo.sucursal_Id}
                HandlePredictCat={() => { }}
                claveCategoria={claveCategoria}
                CloseModal={closeModal}
                Save={saveCategoriasArt}
            />);
            case 'atributos': return (<FormFichaTecnica key={modalKey} data={item} Save={SaveAtributos} CloseModal={closeModal} />);
            case 'costos': return (<FormCostos key={modalKey} data={item} tienda={tienda} imagenes={item.imagenes} Save={SaveArt} CloseModal={closeModal} />);
            case 'variantes':
            default: return (<GeneralForm key={modalKey} data={item} isGeneralForm={true} Save={SaveArt} onClose={closeModal} />);
        }
    }

    const handleChangeCategoria = (categoriaId) => {
        SetClaveCategoria(categoriaId);
    };

    const saveCategoriasArt = (art) => {
        saveCategorias(art);
        closeModal();
    }

    const SaveArt = (art) => {
        SaveArtSimple(art);
        closeModal();
    }

    const SaveImgArt = (art) => {
        SaveArtImg(art);
        closeModal();
    }

    const SaveAtributos = (art) => {
        SaveArtAtributos(art);
        closeModal();
    }

    function onclick(id) {
        setAnchorEl(null);
        if (id !== 'eliminar') {
            SetClaveCategoria(articulo?.clave_Categoria);
            setModalKey(prev => prev + 1);
            setKeyModal(id);
            openModal();
        }
        else onDeleteItem(item.id);
    }

    return (<>
        <IconButton onClick={((e) => setAnchorEl(e.currentTarget))}><MoreVertIcon /></IconButton>
        <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={(() => setAnchorEl(null))} MenuListProps={{ 'aria-labelledby': 'basic-button', }}>
            <MenuItem id='detalles' onClick={((e) => onclick('detalles'))}><ListItemIcon><InfoIcon fontSize="small" /></ListItemIcon>Ver Detalles</MenuItem>
            <MenuItem id='general' onClick={((e) => onclick('general'))}><ListItemIcon><RateReviewIcon fontSize="small" /></ListItemIcon>Edicion General</MenuItem>
            <MenuItem id='imagenes' onClick={((e) => onclick('imagenes'))}><ListItemIcon><BurstModeIcon fontSize="small" /></ListItemIcon>Editar Imagenes</MenuItem>
            <MenuItem id='descripcion' onClick={((e) => onclick('descripcion'))}><ListItemIcon><DescriptionIcon fontSize="small" /></ListItemIcon>Editar Descripcion</MenuItem>
            <MenuItem id='categoria' onClick={((e) => onclick('categoria'))}><ListItemIcon><TaskIcon fontSize="small" /></ListItemIcon>Editar Categoria{tienda !== 'MERCADOLIBRE' && ' y Atributos'}</MenuItem>
            {tienda === 'MERCADOLIBRE' && <MenuItem id='atributos' onClick={((e) => onclick('atributos'))}><ListItemIcon><BallotIcon fontSize="small" /></ListItemIcon>Editar Atributos</MenuItem>}
            <MenuItem id='costos' onClick={((e) => onclick('costos'))}><ListItemIcon><AttachMoneyIcon fontSize="small" /></ListItemIcon>Editar {tienda !== 'MERCADOLIBRE' ? 'Precios' : 'Costos'}</MenuItem>
            {/*<MenuItem id='variantes' onClick={((e) => onclick('variantes'))}><ListItemIcon><ViewQuiltIcon fontSize="small" /></ListItemIcon>Editar Variantes</MenuItem>*/}
            {/*<MenuItem id='envio_gratis' onClick={((e) => onclick('envio_gratis'))}><ListItemIcon><LocalShippingIcon fontSize="small" /></ListItemIcon>Establecer envio gratis</MenuItem>*/}
            <MenuItem id='eliminar' onClick={((e) => onclick('eliminar'))}><ListItemIcon><DeleteIcon fontSize="small" /></ListItemIcon>Eliminar </MenuItem>
            {/*<MenuItem id='log' onClick={((e) => onclick('log'))}><ListItemIcon><TerminalIcon fontSize="small" /></ListItemIcon>Ver Log</MenuItem>*/}
        </Menu>
        <Modal key={modalKey} isOpen={isOpenModal} closeModal={closeModal} max={tienda === 'MERCADOLIBRE' ? true : keyModal !== 'costos'}>{GetModalByMenu()}</Modal>
    </>);
}

const FormDescripcion = ({ item, Save, CloseModal }) => {
    const { t } = useTranslation("common");
    const [articulo, setArticulo] = useState(item);

    function handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setArticulo({
            ...articulo,
            [name]: value
        });
    }

    const SaveArt = () => Save(articulo);

    return (<div style={{ display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
        <div className='espacio15px' />
        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', minHeight: '65vh' }}>
            <label htmlFor='descripcion' className='form-label'>{t('app.Articulos.form.descripcionArt')}*</label>
            <textarea className='form-control' name='descripcion' required={true} rows="15" value={articulo.descripcion || ''} onChange={handleInputChange} />
        </div>
        <div className='espacio5px' />
        <div className='row'>
            <div className='col-sm-8' />
            <div className='col-sm-2'>
                <button className='btn btn-outline-danger' onClick={CloseModal}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-x-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z' />
                    </svg>
                    &nbsp; &nbsp; {t('app.botones.cancelar')}
                </button>
            </div>
            <div className='col-sm-2'>
                <button className='btn btn-outline-success' onClick={SaveArt}>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='20'
                        height='20'
                        fill='currentColor'
                        className='bi bi-check-lg'
                        viewBox='0 0 16 16'
                    >
                        <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
                    </svg>
                    &nbsp; {t('app.botones.guardar')}
                </button>
            </div>
        </div>
    </div>);
}

export { TablePublicador };